import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { Typography } from '@material-ui/core';
import { useTranslation } from "react-i18next";


export default function ConfirmDialog(props) {
    const { openDialog, setOpenDialog, handleConfirm } = props
    const { t } = useTranslation("global")

    function handleClose() {
        setOpenDialog(false);
    }

    return (

        <Dialog
            open={openDialog}
            onClose={handleClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle id="alert-dialog-title">{t("sLogin.dialogTitle")}</DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-description">
                    <Typography align='justify'>
                        {t("sLogin.dialogText")}
                    </Typography>
                </DialogContentText>
            </DialogContent>
            <DialogActions className="sig_Actions_ConfirmRegisterDialog">
                <Button onClick={handleClose} autoFocus>
                    {t("sLogin.dialogDisagree")}
                </Button>
                <Button onClick={handleConfirm}>
                    {t("sLogin.dialogAgree")}
                </Button>
            </DialogActions>
        </Dialog>
    );
}
